var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-icon-btn',{attrs:{"icon-height":"15","access":_vm.isShowCollectionInfo,"show-tooltip":"","bottom":"","icon-name":"mdi-information-outline"},on:{"click":_vm.showInfo}},[_vm._v(" Info ")])}
var staticRenderFns = []

export { render, staticRenderFns }